import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-file',
  template: `
    <div class="flex items-center gap-3">
      <p-fileupload
        mode="basic"
        [auto]="true"
        [customUpload]="true"
        [chooseLabel]="props['chooseLabel'] || 'Choose file'"
        [accept]="props['accept'] || '*'"
        chooseIcon="pi pi-upload"
        (onSelect)="onSelect($event)"
      />
      @if (control.value) {
        <span class="text-xs text-gray-500">File attached</span>
        <a class="text-xs text-primary-600 cursor-pointer" (click)="clear()">Remove</a>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFileComponent extends FieldType {
  get control(): FormControl {
    return this.formControl as FormControl;
  }

  onSelect(event: { files?: File[]; currentFiles?: File[] }) {
    const file = event.files?.[0] ?? event.currentFiles?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => this.control.setValue(reader.result as string);
    reader.readAsDataURL(file);
  }

  clear() {
    this.control.setValue(null);
  }
}
